import React from "react";


import {
    Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import {
    FormFieldStatusInterface
} from "@Elements";


import IconSuccessRoundXsGreen from "./@Icons/icon-success_round-xs-green.svg";
import IconErrorRoundXsRed from "./@Icons/icon-error_round-xs-red.svg";


import "./index.scss";


interface FormFieldStatusComponentProps {
    formFieldStatus: FormFieldStatusInterface;
}


export const FormFieldStatusComponent:React.FC<FormFieldStatusComponentProps> = ({
    formFieldStatus
}) => {


    const {
        statusType, statusMessage
    } = formFieldStatus;


    let StatusIcon;

    switch (statusType) {
        case "success":
            StatusIcon = IconSuccessRoundXsGreen;
            break;
        case "error":
            StatusIcon = IconErrorRoundXsRed;
            break;
    }


    return (
        <Col xs={12} className={`form-field-status-component form-field-status-component--${statusType}-status`}>
            <SvgIconComponent iconSource={StatusIcon} className={`form-field-status-component__status-icon form-field-status-component--${statusType}-status__status-icon`} />
            <span className={`form-field-status-component__status-message form-field-status-component--${statusType}-status__status-message`}>{statusMessage}</span>
        </Col>
    );

};


export default FormFieldStatusComponent;
